import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import { myLocalStorage } from "../../../StorageHelper";

export const getAWSAllUsers = async (latestTenant: string, selectedAwsAccount: string) => {

    let url = `${NGROK}/api/aws/getIamusers?tenantName=${latestTenant}&accountId=${selectedAwsAccount}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    const flattenedData = Object.values(data).flatMap((item) => item);
    return flattenedData;
};

export const getAWSAllGroups = async (latestTenant: string, selectedAwsAccount: string) => {
    let url = `${NGROK}/api/aws/getIamgroups?tenantName=${latestTenant}&accountId=${selectedAwsAccount}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};


export const fetchAWSAccountList = async (latestTenant: string) => {
    let url = `${NGROK}/api/aws/getAllAccounts?tenantName=${latestTenant}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};

export const fetchAWSTenantAccountList = async (latestTenant: string, tenantEmail: string) => {
    const url = `${NGROK}/api/aws/getAWSUserConfig?tenantName=${latestTenant}&tenantEmail=${tenantEmail}`;
    const data = await apiClient({
        method: "GET",
        url,
    });
    return data;
};